import gql from 'graphql-tag';

export const createAnnouncementMutation = gql`
  mutation createAnnouncementMutation($attributes: WWS_CreateAnnouncementAttrs!) {
    createAnnouncement(attributes: $attributes) {
      id
      message
      show
    }
  }
`;

export const updateAnnouncementMutation = gql`
  mutation updateAnnouncementMutation($attributes: WWS_UpdateAnnouncementAttributes!) {
    updateAnnouncement(attributes: $attributes) {
      id
      message
      show
    }
  }
`;

export const weddingDatePreferencesQuery = gql`
  query weddingDatePreferences {
    weddingDatePreferences {
      datePreference
      hideDate
      season
      year
      weddingDate
      weddingDateFormat
      weddingDateRangeStart
      weddingDateRangeEnd
      hideCountdown
    }
  }
`;
